import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import * as dealsAPI from '../../../apis/dealsAPI'
import type { DealEntity } from '../../../apis/dealsAPI'

import { DEALS_QUERY_KEY_ROOT } from './useDealsQuery'

export function dealQueryKey(dealId: string): readonly unknown[] {
  return [...DEALS_QUERY_KEY_ROOT, 'detail', dealId]
}

export function useDealQuery(dealId: string | null): UseQueryResult<DealEntity> {
  return useQuery<DealEntity>(
    dealQueryKey(dealId ?? ''),
    () => dealsAPI.getDeal(dealId as string),
    { enabled: dealId !== null && dealId !== '' },
  )
}
